import React, { useState } from 'react';
import { authorizeLimitedInput } from '../../connection/limited-device-auth'; 
import { useSelector } from 'react-redux';
const AuthorizeDevice = () => {
  const [uniqueCode, setUniqueCode] = useState('');
  const [authStatus, setAuthStatus] = useState(null);

  const token = useSelector((state: any) => state.SessionReducer.token);
  const roomId = useSelector((state: any) => state.SessionReducer.roomId);

  const handleSubmit = (e:any) => {
    e.preventDefault();
    const roomUrl = window.location.href;
    authorizeLimitedInput(uniqueCode, roomUrl)
  };

  return (
    <div>
      <h2>Enter Code</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={uniqueCode}
          onChange={(e) => setUniqueCode(e.target.value)}
          placeholder="Enter code"
          required
        />
        <button type="submit">Authenticate</button>
      </form>
      {authStatus && <p>{authStatus}</p>}
    </div>
  );
};

export default AuthorizeDevice;